module.exports = __webpack_public_path__ + "img/D7D7C3_AAAA92_F5F5EA_BCBCA4-256px.956923b2.png";